// extracted by mini-css-extract-plugin
export default {"heroSection":"Header_heroSection__aZRXC","logoBox":"Header_logoBox__0DD7g","logo":"Header_logo__z8t+y"};